import { useMutation, useQueryClient } from 'react-query'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useCheckRole } from '@ospace/auth'
import { useCampaign } from '@ospace/campaign'
import { userTypes } from '@ospace/core-auth'
import { PageTitle } from '@ospace/layout'
import { ErrorBoundary, useNotificationContext } from '@ospace/shared'

import { ContactReviewTable } from '../components/ContactReviewTable'
import { ContactService } from '../services'

type Props = { campaignId: number }
export const ContactReviewPage = (props: Props) => {
  const { setNotification } = useNotificationContext()
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useQueryClient()
  const { data: campaign } = useCampaign(props.campaignId)

  const mutation = useMutation(
    (contact: any) => {
      contact.campaignId = props.campaignId
      contact.lookerClientId = campaign?.lookerClientId
      return ContactService.processContact(contact)
    },
    {
      onSuccess: () => {
        setNotification({
          active: true,
          message:
            'You have successfully uploaded contacts and it is being processed. Please check back in couple of minutes',
          type: 'success',
        })
        navigate(`/campaign/${props.campaignId}/contact`)
        queryClient.refetchQueries(['contacts', props.campaignId])
      },
      onError: (e: any) => {
        setNotification({
          active: true,
          message: e.response?.data || e.message,
          type: 'danger',
        })
      },
    }
  )

  return (
    <>
      <PageTitle>Upload Contacts</PageTitle>
      <div className='card'>
        <ContactReviewTable
          contacts={location?.state?.data}
          payload={location?.state?.payload}
          mutation={mutation}
        />
      </div>
    </>
  )
}

const Controller = () => {
  useCheckRole([userTypes.Admin, userTypes.ClientManager, userTypes.CampaignManager])
  const params: any = useParams()
  const campaignId = Number(params?.id)
  return <ContactReviewPage campaignId={campaignId} />
}

export const ContactReviewPageRouteHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)
